export function ingestGapsToCsv(report: {
  groups: Array<{
    brand: string;
    brandId: string | null;
    scraperImplemented: boolean;
    scraperEnabled: boolean;
    recommendedAction: string;
    skus: Array<{
      model: string;
      description?: string;
      productType?: string;
      productStatus: string;
      pricingSource?: string;
      mapPrice?: number;
      instantRebate?: number;
      status?: string;
    }>;
  }>;
}): string {
  const headers = [
    'brand',
    'brandId',
    'model',
    'description',
    'productType',
    'productStatus',
    'pricingSource',
    'mapPrice',
    'instantRebate',
    'status',
    'scraperImplemented',
    'scraperEnabled',
    'recommendedAction',
  ];

  const escape = (value: unknown): string => {
    const s = String(value ?? '');
    if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };

  const lines = [headers.join(',')];
  const groups = [...report.groups].sort((a, b) => a.brand.localeCompare(b.brand));
  for (const group of groups) {
    for (const sku of group.skus) {
      lines.push(
        [
          group.brand,
          group.brandId || '',
          sku.model,
          sku.description || '',
          sku.productType || '',
          sku.productStatus,
          sku.pricingSource || '',
          sku.mapPrice ?? '',
          sku.instantRebate ?? '',
          sku.status || '',
          group.scraperImplemented,
          group.scraperEnabled,
          group.recommendedAction,
        ]
          .map(escape)
          .join(',')
      );
    }
  }
  return `${lines.join('\n')}\n`;
}
